import { render, staticRenderFns } from "./InvitationSharingModule.vue?vue&type=template&id=69b2d74f&scoped=true"
import script from "./InvitationSharingModule.vue?vue&type=script&lang=js"
export * from "./InvitationSharingModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b2d74f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69b2d74f')) {
      api.createRecord('69b2d74f', component.options)
    } else {
      api.reload('69b2d74f', component.options)
    }
    module.hot.accept("./InvitationSharingModule.vue?vue&type=template&id=69b2d74f&scoped=true", function () {
      api.rerender('69b2d74f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/InvitationSharingModule.vue"
export default component.exports